module.exports = __webpack_public_path__ + "img/Component 14@2x.f056cc93.png";